import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';
import { CommonModule } from '@angular/common';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { RelocationRoutingModule } from './relocation-routing.module';
import { RelocationEditContainer } from './relocation-edit-container/relocation-edit.container';
import { RelocationEditDetailComponent } from './relocation-edit-detail/relocation-edit-detail.component';
import { RelocationEditPlanningComponent } from './relocation-edit-planning/relocation-edit-planning.component';
import { RelocationEditMaterialComponent } from './relocation-edit-material/relocation-edit-material.component';
import { RelocationMaterialLinesComponent } from './relocation-material-lines/relocation-material-lines.component';
import { RelocationEditDeliveryComponent } from './relocation-edit-delivery/relocation-edit-delivery.component';

@NgModule({
  imports: [CommonModule, FlorderModule, RelocationRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  exports: [RelocationEditDeliveryComponent, RelocationEditDetailComponent, RelocationEditPlanningComponent],
  declarations: [
    RelocationEditContainer,
    RelocationEditDeliveryComponent,
    RelocationEditDetailComponent,
    RelocationEditPlanningComponent,
    RelocationEditMaterialComponent,
    RelocationMaterialLinesComponent,
  ],
  providers: [],
})
export class RelocationModule {}
